import { type ReactElement, lazy, useCallback, useEffect, useState } from 'react'

import { useSearchParams } from 'react-router-dom'

import { Loader } from '../components/Loader'
import { getVerifiedCredentialsUserEmail } from '../services/api/auth'
import { environmentVariables } from '../utils/environmentVariables'
import { ErrorCodes } from '../utils/errors'
import { redirectToUrl } from '../utils/location'
import { QueryParameters } from '../utils/queryParameters'

export const LazyChangeEmailPage = lazy(() =>
  import('../pages/ChangeEmailPage').then((module) => ({
    default: module.ChangeEmailPage,
  })),
)

export const ChangeEmailRoute = (): ReactElement => {
  const [hasUserVerifiedCredentials, setHasUserVerifiedCredentials] = useState(false)
  const [searchParams] = useSearchParams()

  const getUserEmail = useCallback(async () => {
    if (searchParams.get('change_email') === 'true') {
      setHasUserVerifiedCredentials(true)
      return Promise.resolve()
    }

    try {
      await getVerifiedCredentialsUserEmail()
      setHasUserVerifiedCredentials(true)
    } catch (error) {
      // If the response from getVerifiedCredentialsUserEmail is not a 200, the user has not verified his credentials.
      const query = `${QueryParameters.ERROR_CODE}=${ErrorCodes.EXPIRED_SESSION}`
      redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin?${query}`)
    }
  }, [searchParams])

  useEffect(() => {
    getUserEmail()
  }, [getUserEmail])

  if (hasUserVerifiedCredentials) {
    return <LazyChangeEmailPage />
  }

  return <Loader />
}
